import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';
import { formatDate } from '../../utils';
import { blogPosts } from './landingContent';

const getPostHref = (post) => (post.slug ? `/blog/${post.slug}` : '/blog');

const getPostDate = (post) => {
  if (!post.created_at) {
    return post.date;
  }

  return formatDate(post.created_at);
};

const normalizePost = (post) => ({
  id: post.id || post.slug || post.title,
  title: post.title,
  short_description: post.short_description || '',
  author: post.author,
  slug: post.slug,
  date: getPostDate(post),
});

const LandingBlogPosts = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchPosts = async () => {
      try {
        const response = await fetch(`${config.endpoints.baseUrl}/api/posts/list?page=1&per_page=3`);

        if (!response.ok) {
          throw new Error(`Unable to load blog posts: ${response.status}`);
        }

        const result = await response.json();

        if (isMounted) {
          setPosts(result?.data || []);
        }
      } catch (error) {
        console.error('Error fetching landing blog posts:', error);
      }
    };

    fetchPosts();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="bl-blog" id="blog">
      <div className="bl-blog__shell">
        <div className="bl-blog__eyebrow">Blog</div>
        <div className="bl-blog__header">
          <h2 className="bl-blog__title">Insights from the team.</h2>
          <Link className="bl-blog__note" to="/blog">
            View all posts -&gt;
          </Link>
        </div>
        <div className="bl-blog__grid">
          {(posts.length > 0 ? posts : blogPosts).map(normalizePost).map((post) => (
            <article className="bl-blog-card" key={post.id}>
              <div className="bl-blog-card__meta">{post.author} · {post.date}</div>
              <h3 className="bl-blog-card__title">{post.title}</h3>
              <p className="bl-blog-card__excerpt">{post.short_description}</p>
              <Link className="bl-blog-card__link" to={getPostHref(post)}>
                Read article -&gt;
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingBlogPosts;
